import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const InquiryReviewerResponseCover = ({ notification, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `تم الرد على تفاعلك مع متلطب ${sender?.name}`
    : `Your interaction with inquiry of ${sender?.name}, has a response`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default InquiryReviewerResponseCover
